import React, {useEffect, useRef, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import API from '../../app/api';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import config from '../../app/config';
import {AutocompleteDictionary} from './autocomplete';
import {Button, Fade, List, ListItem, ListItemButton, Tooltip, Typography} from '@mui/material';
import {calculateArrivalDate} from '../../util/patientUtil';
import {useDispatch, useSelector} from 'react-redux';
import {user} from '../../store/reducers/user';
import _ from 'lodash';
import MessageBox from '../../util/messageBox';
import keyPerformanceIndicator from '../../util/timeMarker';
import {setSnackbar} from '../../store/reducers/globals';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
import uuidv4 from 'uuid/v4';
import clsx from 'clsx';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {isMobile} from 'react-device-detect';
import {patientBanner} from './tasks/components/patientBanner';
import useOpenState from '../../hooks/useOpenState';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import AgyleDatePicker from '../../components/ui/fields/agyleDatePicker';
import AgyleDialog from '../../components/modal/agyleDialog';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';
import NewNoteModal from '../../components/notes/component/newNoteModal';
import useDict from '../../hooks/useDict';
import {specialties as specialtiesReducer} from '../../store/reducers/preferences';
import useConsultantsDict from '../../hooks/useConsultantsDict';
import PropTypes from 'prop-types';
import MiniFormDialog from '../../components/modal/miniFormDialog';
//TODO For refactor @Mateusz
const useStyles = makeStyles((theme) => ({
    colorSystem: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: 'inline-block',
        marginRight: 10,
        verticalAlign: 'middle',
        border: '1px solid #222',
    }, colorSystemTextBox: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: 'inline-block',
        marginRight: 5,
        marginLeft: 5,
        verticalAlign: 'middle',
        border: '1px solid #222',
    }, discriminator: {
        display: 'inline-block', verticalAlign: 'middle',
    }, error: {
        color: '#f44336',
    }, input: {
        width: '100%', fontSize: '15px', marginBottom: 10, borderRadius: '6%',
    }, noteField: {
        marginTop: '15px',
        width: '100%',
    }, agyleButton: {
        backgroundColor: '#448FFF',
    }, checkBtn: {
        width: '35%', maxWidth: '135px', height: '37px', background: '#C33131', // display: "inline-block",
        display: 'flex', justifyContent: 'center', alignItems: 'center', // textAlign: "center",
        lineHeight: '35px', fontSize: '0.9em',

    }, checked: {
        background: '#69BB69', textAlign: 'center', padding: '10px 20px', maxWidth: '135px', width: '35%',
    }, historyLabel: {
        '& .label-part1': {
            fontWeight: 'bold',
        }, '& .label-part2': {
            fontWeight: 'normal', margin: '0 10px', wordBreak: 'break-word',
        }, '& .label-part3': {
            fontSize: '90%', opacity: .7, whiteSpace: 'break-spaces',
        },
    }, noteItem: {
        width: '100%', maxWidth: '357px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        maxHeight: '51px', display: 'flex', alignItems: 'center', paddingLeft: '5px',
    }, indexNumber: {
        display: 'inline-block', backgroundColor: theme.palette.mode === 'light' ? '#9a9593' : 'white', color: 'black',
        fontWeight: 'bold', padding: '5px 10px', borderRadius: '5px', marginRight: '10px', width: '34px',
        height: '34px', textAlign: 'center',
    }, noteText: {
        display: 'inline-block', border: '1px solid #626466', padding: '5px 10px', borderRadius: '10px',
        minWidth: '100px', width: '100%', maxWidth: '290px', overflow: 'hidden',
    }, listItem: {
        display: 'flex',
    }, checkedBy: {
        fontSize: '8px', marginBottom: '-20px', '&.mobile': {
            fontSize: '6px',
        },
    }, checkedByTimestampText: {
        fontSize: '8px', '&.mobile': {
            fontSize: '6px',
        },
    }, notCompletedTimestampText: {
        fontSize: '12px', '&.mobile': {
            fontSize: '6px',
        },
    },
}));

export const consultantDictionary = {
    seeAndTreat: 'seeAndTreat',
    rapidAssessment: 'rapidAssessment',
    currentClinician: 'currentClinician',
    ambulanceHandover: 'ambulanceHandover',
    triage: 'triage',
    clerking: 'clerking',
    csmContactTime: 'csmContactTime',
    handover: 'handover',
    medicalPlan: 'medicalPlan',
    nursingPlan: 'nursingPlan',
    nursingChecklistQuestions: 'nursingChecklistQuestions',
    medicalChecklistQuestions: 'medicalChecklistQuestions',
    currentNurse: 'currentNurse',
    clinicalConclusion: 'clinicalConclusion',
    seniorReview: 'seniorReview',
    discharge: 'discharge',
    treatmentPlan: 'treatmentPlan',
    bedBooking: 'bedBooking',
    arrival: 'arrival',
    nurseForm: 'nurseForm',
    admitting: 'admitting',
    //book admission module
    mduEditFormAdmissionConsultant: 'mduEditFormAdmissionConsultant',
    tciEditFormOverseeingConsultant: 'tciEditFormOverseeingConsultant',
    patientListFilterOverseeingConsultant: 'patientListFilterOverseeingConsultant',
    workListFilterOverseeingConsultant: 'workListFilterOverseeingConsultant',
    sessionModalOverseeingConsultant: 'sessionModalOverseeingConsultant',
    sessionModalAnaesthetist: 'sessionModalAnaesthetist',
    sessionModalSurgeon: 'sessionModalSurgeon',
    mySessionSurgeon: 'mySessionSurgeon',
    mySessionAnaesthetist: 'mySessionAnaesthetist',
    mySessionOverseeingConsultant: 'mySessionOverseeingConsultant',
    admissionFilterOverseeingConsultant: 'admissionFilterOverseeingConsultant',
    admissionFilterSurgeon: 'admissionFilterSurgeon',
    admissionFilterAnaesthetist: 'admissionFilterAnaesthetist',
    //end book admission module
};

//Helper functions
function getConsultantName(consultant) {
    let name = '';
    if (!consultant) {
        return 'Not Set';
    }

    if (typeof consultant === 'string') {
        return consultant;
    }

    if (consultant.__description) {
        name = consultant.__description;
    }

    if (consultant.familyName) {
        if (consultant.firstName) {
            name = `${_.capitalize(consultant.familyName)}, ${_.capitalize(consultant.firstName)}`;
        } else {
            name = `${_.capitalize(consultant.familyName)}`;
        }
    }

    return name;
}

function getConsultantCode(consultant, defResult = '') {
    let code = '';
    if (!consultant) {
        return 'Not Set';
    }

    if (typeof consultant === 'string') {
        return defResult;
    }

    if (consultant.hasOwnProperty('__code') && consultant['__code'] != null) {
        code = consultant.__code;
    } else {
        if (consultant.hasOwnProperty('code') && consultant['code'] != null) {
            code = consultant.code;
        } else {
            if(consultant.hasOwnProperty('pasCode') && consultant['pasCode'] != null){
                code = consultant.pasCode;
            } else {
                if(consultant.hasOwnProperty('_id') && consultant['_id'] != null){
                    code = consultant._id;
                }
                else {
                    code = consultant.__id;
                }

            }
        }
    }
    return code;
}

// Presentation
function ControlClinician(props) {
    const controller = new AbortController();
    const type = props.typeDict ? props?.typeDict : 'Clinicians';

    const init = useRef(true);

    useEffect(async () => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
        }

        if (!props.loading && props.findUser && !_.isNil(props.findUser) && _.isNil(props.value) && init.current) {
            let userClinician;
            await API.getDictByURL(`/$dict/${type}?$filter=${encodeURIComponent(newFilter)}`, controller.signal).then((dictData) => {
                if (dictData) {
                    for (let clinician of dictData.__data) {
                        if (clinician.userName === props.findUser) {
                            userClinician = clinician;
                            break;
                        }
                    }
                }
            });

            if (userClinician) {
                props.onChange(userClinician, true);
                init.current = false;
            }
        }

        return () => {
            controller.abort();
        };
    }, [props.value, props.loading]);

    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
            if (filter !== '') {
                newFilter = `(${props.filterBy} eq true and deactivated ne true) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and ' + filter;
            }
        }

        return `/$dict/${type}?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const getClinicianURL = (clinicianType, filter) => {
        let newFilter = 'deactivated ne true';

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true)`;
            if (filter !== '') {
                newFilter = `(${props.filterBy} eq true and deactivated ne true) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and ' + filter;
            }
        }

        return `/$dict/${clinicianType}?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const renderOptionLine = (createParts, option, classes, props) => {
        //return <div {...props}>{option.__description}</div>;
        return <div {...props}>{getConsultantName(option)}</div>;
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            //getOptionLabel={(option) => option?.__description ? option.__description : ''}
            getOptionLabel={(option) => getConsultantName(option)}
            renderLocalOption={renderOptionLine}
            searchColumnName="description"
            dictionaryURL={getDictionaryURL}
            getClinicianURL={getClinicianURL}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (<Chip
                //label={option.__description}
                label={getConsultantName(option)}
                {...getTagProps({index})}
            />))}
            isOptionEqualToValue={(option, value) => {
                return option?.__id === value?.__id;
            }}
            noBorder={!props.refresh}
            withNewBackground={props.refresh}
            {...props}
            size={props.refresh ? 'large' : props.size || 'small'}
        />
    );
}

function ControlConsultant(props) {
    const controller = new AbortController();

    const init = useRef(true);
    let ds = '';

    const renderOptionLine = (createParts, option, classes, props, type, allOptions = []) => {
        let optionLabel = getConsultantName(option);
        return <Tooltip
            title={optionLabel + ' (' + getConsultantCode(option) + ')'}
            enterTouchDelay={600} enterDelay={1500}
            placement={'left'} arrow>
            <div {...props} key={'renderOptionLine_' + option.__id}>
                <div>{optionLabel}</div>
            </div>
        </Tooltip>;
    };

    const optionLabel = (option) => {
        // return `${_.capitalize(option.familyName)}, ${_.capitalize(option.firstName)}`;
        return getConsultantName(option);
    };

    useEffect(async () => {
        let newFilter = 'deactivated ne true and availableIn ne null';
        if (props.allowedConsultants) {
            newFilter += ' and availableIn eq \'' + props.allowedConsultants + '\'';
        }

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true and availableIn ne null)`;
        }
        if (!props.loading && init.current &&
            props.findUser &&
            !_.isNil(props.findUser) &&
            _.isNil(props.value)
        ) {
            let userClinician;
            await API.getDictByURL(
                `/consultants?$filter=${encodeURIComponent(newFilter)}`,
                controller.signal,
            ).then((dictData) => {
                if (dictData) {
                    userClinician = _.find(dictData.__data, (clinician) => clinician.userName === props.findUser);
                    // for (let clinician of dictData.__data) {
                    //     //if (clinician.userName === props.findUser && clinician.availableIn.includes(allowedConsultants)) {
                    //     if (clinician.userName === props.findUser) {
                    //         userClinician = clinician;
                    //         break;
                    //     }
                    // }
                }
            });

            if (userClinician) {
                props.onChange(userClinician, true);
                init.current = false;
            }
        }

        return () => {
            controller.abort();
        };
    }, [props.value, props.loading]);

    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true and availableIn ne null';

        if (props.allowedConsultants) {
            newFilter += ' and availableIn eq \'' + props.allowedConsultants + '\'';
        }

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true and availableIn ne null)`;
            if (filter !== '') {
                newFilter =
                    `(${props.filterBy} eq true and deactivated ne true and availableIn ne null) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and availableIn ne null and ' + filter;
            }
        }
        return `/consultants?$filter=${encodeURIComponent(
            newFilter,
        )}&$sort=familyName`;
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            getOptionLabel={optionLabel}
            allowedConsultants={props.allowedConsultants}
            renderLocalOption={renderOptionLine}
            multiSearchColumnName={['familyName', 'firstName']}
            dictionaryURL={getDictionaryURL}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                <Chip
                    label={getConsultantName(option)}
                    {...getTagProps({index})}
                />
            ))
            }
            isOptionEqualToValue={(option, value) => {
                return option?.__id === value?.__id;
            }}
            cliniciansWithNurses={false}
            noBorder={!props.refresh}
            withNewBackground={props.refresh}
            {...props}
            size={props.refresh ? 'large' : props.size || 'small'}
        />
    );
}

ControlConsultant.propTypes = {
    allowedConsultants: PropTypes.string.isRequired,
};

//deprecated
function ControlConsultants(props) {
    const classesLocal = useStyles();

    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true';
        if (filter !== '') {
            newFilter = 'deactivated ne true and ' + filter;
        }
        return `/consultants?$filter=${encodeURIComponent(newFilter)}&$sort=familyName`;
    };

    const renderOptionLine = (createParts, option, classes, props) => {
        return (<div {...props}>{option?.familyName + ', ' + option?.firstName}</div>);
    };

    return (<AutocompleteDictionary
        showAll
        getOptionSelected={(option, value) => option.__id === value.__id}
        getOptionLabel={(option) => option?.familyName && option?.firstName ? `${_.startCase(option.familyName)}, ${_.startCase(option.firstName)}` : ''}
        renderLocalOption={renderOptionLine}
        multiSearchColumnName={['familyName', 'firstName']}
        dictionaryURL={getDictionaryURL}
        {...props}
    />);
}

const IsolatedMenu = ({note, deleteNote, editNote, user}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    const userName = `${user?.firstName} ${user?.familyName}`;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    return (<div>
        <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
        >
            <MenuIcon/>
        </IconButton>
        <Menu
            id={note.id}
            MenuListProps={{
                'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem
                // disabled={!(note?.checkedBy === userName || dispatch(hasPermission(Permissions.AGYLE_CAN_MENAGE_PREVIOUS_VALUES)))}
                onClick={() => {
                    deleteNote(note);
                    handleClose();
                }}
                style={{display: 'flex', justifyContent: 'space-around'}}
            >
                <IconButton
                >
                    <DeleteIcon/>
                </IconButton>
                Delete
            </MenuItem>
            <MenuItem
                // disabled={!(note?.checkedBy === userName || dispatch(hasPermission(Permissions.AGYLE_CAN_MENAGE_PREVIOUS_VALUES)))}
                onClick={() => {
                    editNote(note);
                    handleClose();
                }}
            >
                <IconButton>
                    <EditIcon/>
                </IconButton>
                Edit
            </MenuItem>
        </Menu>
    </div>);
};

function ControlConsultantComponent(props) {
    if (config?.consultantComponentEnabled) {
        return <ControlConsultant {...props} />;
    } else {
        return <ControlClinician {...props} />;
    }
}

const MedicalNurseNotes = ({notes, setNotes, setFormIsModified, user, setAddBtnSeen, setInitialNote, handleConfirm}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const userName = `${user?.firstName} ${user?.familyName}`;
    const grid = 8;
    const notesCount = notes.length;

    const deleteNote = note => {
        setNotes(notes.filter(n => n.id !== note.id));
        setFormIsModified(true);
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const items = reorder(notes, result.source.index, result.destination.index);

        setNotes(items);
        setFormIsModified(true);
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: 'none',

        ...draggableStyle,
    });

    const getListStyle = (isDraggingOver) => ({
        height: `${notesCount * 51 + grid}px`,
        width: '100%',
    });

    const checkNote = note => {
        const tempNote = {
            ...note, checked: !note.checked, timestamp: moment(), checkedBy: userName,
        };
        if (!tempNote.checked) {
            handleConfirm(tempNote);
        } else {
            let notesTemp = notes.map(n => n.id === note.id ? tempNote : n);
            notesTemp = _.sortBy(notesTemp, ['checked']);
            setNotes(notesTemp);
            setFormIsModified(true);
        }
    };

    const editNote = localNote => {
        setAddBtnSeen(true);
        setInitialNote(localNote);
        setNotes(prev => prev.filter(n => n.id !== localNote.id));
        setFormIsModified(true);
    };

    return (<DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
            {(provided, snapshot) => (<List
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
            >
                {notes && notes.map((note, index) => (
                    <Draggable key={note.id} draggableId={note.id} index={index}>
                        {(provided, snapshot) => (<ListItem
                            disablePadding
                            key={note.id}
                            className={classes.listItem}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <ListItemButton className={classes.noteItem}>
                                <div className={classes.noteItem}>
                                    <span className={classes.indexNumber}>{index + 1}</span>

                                    <Tooltip title={note.text} TransitionComponent={Fade}
                                             TransitionProps={{timeout: 600}} style={{minWidth: '105px'}}>
                                        <span className={classes.noteText}>{note.text.slice(0, 30)}</span>
                                    </Tooltip>
                                </div>
                            </ListItemButton>
                            <Button
                                variant="contained"
                                color="primary"
                                className={clsx(classes.checkBtn, note.checked && classes.checked)}
                                style={{marginRight: '5px'}}
                                onClick={() => checkNote(note)}
                            >
                                {note.checked ? (<Grid container xs={12} flexDirection={'column'}>
                                    <div
                                        className={clsx(classes.checkedBy, isMobile && 'mobile')}
                                    >
                                        {note.checkedBy}
                                    </div>
                                    <div
                                        className={clsx(classes.checkedByTimestampText, isMobile && 'mobile')}
                                    >
                                        {moment(note.timestamp).format(config.defaultDateTimeFormat)}
                                    </div>
                                </Grid>) : (<Typography
                                    variant="body2"
                                    className={clsx(classes.notCompletedTimestampText, isMobile && 'mobile')}
                                >
                                    {t('NOT COMPLETED')}
                                </Typography>)}
                            </Button>

                            <IsolatedMenu
                                id={note.id}
                                note={note}
                                user={user}
                                deleteNote={deleteNote}
                                editNote={editNote}
                            />
                        </ListItem>)}
                    </Draggable>))}
            </List>)}
        </Droppable>
    </DragDropContext>);
};

export function MedicalNursePlanInput(props) {
    const classes = useStyles();
    const {t, i18n} = useTranslation();
    const {
        setFormIsModified,
        medicalNursingNotes,
        setMedicalNursingNotes,
        setAddBtnSeen,
        initialNote,
        setInitialNote,
        initNote,
        user,
        seen,
    } = props;

    // Uncheck note
    const [isConfirmOpen, openConfirm, closeConfirm] = useOpenState(false, true);
    const tempNoteObj = useRef(null);

    const handleConfirm = (note) => {
        tempNoteObj.current = note;
        openConfirm();
    };

    const handleClearStatus = () => {
        if (tempNoteObj.current) {
            let notes = medicalNursingNotes.map(n => n.id === tempNoteObj.current?.id ? tempNoteObj.current : n);

            notes = _.sortBy(notes, ['checked']);
            setMedicalNursingNotes(notes);
            tempNoteObj.current = null;
            closeConfirm();
            setFormIsModified(true);
        }
    };

    const handleAddNote = () => {
        if (initialNote.text) {
            let cloneNotes = medicalNursingNotes ? _.cloneDeep(medicalNursingNotes) : [];
            cloneNotes.push({
                ...initialNote,
                timestamp: moment().toISOString(),
                createdBy: seen?.who,
            });

            cloneNotes = _.sortBy(cloneNotes, ['checked']);

            setMedicalNursingNotes(cloneNotes);
            setInitialNote(initNote);
            setFormIsModified(true);
            setAddBtnSeen(false);
        }
    };

    return (
        <>
            {medicalNursingNotes.length > 0 &&
                <MedicalNurseNotes
                    notes={medicalNursingNotes}
                    setNotes={setMedicalNursingNotes}
                    setFormIsModified={setFormIsModified}
                    user={user}
                    setAddBtnSeen={setAddBtnSeen}
                    setInitialNote={setInitialNote}
                    handleConfirm={handleConfirm}
                />
            }

            <Grid
                container
                className={classes.noteField}
                flexDirection={'row'}
                justifyContent="space-between"
                style={{marginBottom: 15}}
            >
                <AgyleTextField
                    size={props.refresh ? 'large' : 'small'}
                    variant="outlined"
                    className={'custom-dt'}
                    placeholder={t('Enter note (max. 50 characters)')}
                    style={{width: '78%'}}
                    label={t('Note')}
                    onChange={(e) => {
                        setInitialNote((prevValue) => ({
                            ...prevValue, text: e.target.value,
                        }));
                        setFormIsModified(true);
                    }}
                    value={initialNote.text}
                    maxLength={50}
                    noBorder={false}
                    withNewBackground
                />

                <AgyleButton
                    style={{marginTop: 2}}
                    variant="contained"
                    color="primary"
                    onClick={handleAddNote}
                    disabled={!seen?.who}
                >
                    Add Note
                </AgyleButton>
            </Grid>

            <MessageBox
                title={t('Confirmation')}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={handleClearStatus}
                onClose={() => {
                    tempNoteObj.current = null;
                    closeConfirm();
                }}
                message={t('Are you sure you want to uncheck status complete?')}
                open={isConfirmOpen}
            />
        </>
    );
}

function DialogSeen(props) {
    const {t, i18n} = useTranslation();
    const userObject = useSelector(user);
    const classes = useStyles();
    const dispatch = useDispatch();

    const [open, setOpen] = React.useState(props.open || false);
    const [seen, setSeen] = React.useState(props.value);
    const [seenDefault, setSeenDefault] = React.useState(props.value);
    const [isError, setIsError] = useState(false);
    const [errorPicker, setErrorPicker] = useState(null);
    const [formIsModified, setFormIsModified] = React.useState(props.isActionMode);
    const [text, setText] = React.useState(props.value?.text || '');
    const [speciality, setSpeciality] = useState(null);
    const [medicalNursingNotes, setMedicalNursingNotes] = React.useState(props.value?.notes || []);
    const [addBtnSeen, setAddBtnSeen] = React.useState(true);
    const initNote = {id: uuidv4(), text: '', checked: false, checkedBy: null};

    const [initialNote, setInitialNote] = React.useState(initNote);

    const [openConfirmDeleted, setOpenConfirmDeleted] = React.useState(false);
    const [isClinicalNotesOpen, openClinicalNotes, closeClinicalNotes] = useOpenState(false, true);
    const [dictSpecialties, dictSpecialtiesLoading] = useDict('Specialties', '__description', `relevent eq true`);

    const specialties = useSelector(specialtiesReducer);

    useEffect(() => {
        if (open && !props.value?.who && !props.isActionMode && !formIsModified) {
            setFormIsModified(true);
        }
    }, [open, props.isActionMode, props.value]);

    useEffect(() => {
        setIsError(Boolean(!seen?.who || !seen?.when || !_.isNull(errorPicker)));
    }, [seen, errorPicker]);

    const handleClose = (_e, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
            setFormIsModified(false);
            if (props.onClose) {
                props.onClose();
            }
        }
    };

    const handleClear = () => {
        props.withNotes ? props.onChange({
            who: null, when: null, timestamp: null, notes: [],
        }) : props.onChange({
            who: null, when: null, timestamp: null, text: '',
        });
        setOpenConfirmDeleted(false);
        setOpen(false);
        setFormIsModified(false);
    };

    const valid = () => {
        return seen?.who && seen?.when && !errorPicker;
    };

    const sendChange = () => {
        if (valid()) {
            let seenClone = {...seen, timestamp: moment().toISOString()};
            if (props.withText && !props.withNotes) {
                seenClone = {...seenClone, text: text};
            }
            if (props.withNotes) {
                seenClone = {...seenClone, notes: medicalNursingNotes};
            }
            if (props.withSpeciality) {
                seenClone = {...seenClone, speciality: speciality};
            }
            props.onChange(seenClone);
            handleClose();
        }
    };

    const renderTriageButton = () => {
        return (<div onClick={() => {
            if (props.canSeeTriage) {
                sendChange();
                props.onOpen();
                props.openTriageForm();
            } else dispatch(setSnackbar({type: 'warning', message: t('User has no permission to see triage!')}));
        }}>
            <DialogSeen
                patient={props.patient}
                size="small"
                fullWidth={true}
                allowedConsultants={props.allowedConsultants}
                buttonLabel={(value) => {
                    return <span>Submit and open triage form</span>;
                }}
                value={props.patient && props.patient.ambulanceHandover ? props.patient.ambulanceHandover : {
                    who: null, when: moment(),
                }}
                onChange={(value) => {
                    const dataToSave = [{name: 'ambulanceHandover', value: value}];
                    if (value?.when) {
                        keyPerformanceIndicator(dataToSave, props.patient, ['firstInitialAssessment'], {
                            when: value?.when, who: value?.who,
                        });
                    }
                    props.modifyValues(dataToSave);
                }}
            />
        </div>);
    };

    useEffect(() => {
        let isMounted = true;
        let clinicianChanged = false;

        if (!props.ambulanceHandover) {
            if (!props.nurse || props.useNurseAndClinicianDict) {
                API.getDictByURL(`/$dict/Clinicians`).then((dictData) => {
                    if (!isMounted) return;

                    if (dictData) {
                        for (let clinitian of dictData.__data) {
                            if (clinitian.userName === userObject.userName) {
                                setSeenDefault({
                                    who: clinitian,
                                    when: config?.clinicianAndDateDefaultedToCurrentClinician ? moment().toISOString() : seen?.when,
                                });
                                if (!seen?.who || props.planForm || config?.clinicianAndDateDefaultedToCurrentClinician) {
                                    setSeen(prevValue => ({
                                        ...prevValue,
                                        who: clinitian,
                                        when: config?.clinicianAndDateDefaultedToCurrentClinician ? moment().toISOString() : seenDefault?.when,
                                    }));
                                }
                                clinicianChanged = true;
                                break;
                            }
                        }
                    }
                });
            }

            if (props.nurse) {
                API.getDictByURL(`/$dict/Nurses`).then((dictData) => {
                    if (!isMounted) {
                        return;
                    }

                    if (dictData) {
                        for (let clinitian of dictData.__data) {
                            if (clinitian.userName === userObject.userName) {
                                setSeenDefault({
                                    who: clinitian,
                                    when: config?.clinicianAndDateDefaultedToCurrentClinician ? moment().toISOString() : seen?.when,
                                });
                                if (!seen?.who || config?.clinicianAndDateDefaultedToCurrentClinician) {
                                    setSeen(prevValue => ({
                                        ...prevValue,
                                        who: clinitian,
                                        when: config?.clinicianAndDateDefaultedToCurrentClinician ? moment().toISOString() : seenDefault?.when,
                                    }));
                                }
                                clinicianChanged = true;
                                break;
                            }
                        }
                    }
                });
            }

            if (!clinicianChanged && config?.clinicianAndDateDefaultedToCurrentClinician) {
                setSeen(prevState => ({
                    ...prevState,
                    when: moment().toISOString(),
                    who: null,
                }));

                setSeenDefault(prevState => ({
                    ...prevState,
                    when: moment().toISOString(),
                    who: null,
                }));
            }
        }

        return () => {
            isMounted = false;
        };
    }, [open]);

    useEffect(() => {
        if (props.withSpeciality) {
            specialties.forEach((s) => {

                if ('isActive' in s)
                    if (s.isActive) {
                        setSpeciality(s);
                    }

            });
        }
    }, [specialties, open]);

    useEffect(() => {
        if (!open) {
            if (props.openRemote) {
                setOpen(true);
            }
        }
    }, [props.openRemote]);

    const checkIsNursingOrMedicalPlan = () => props.type === 'studies.medicalPlan' || props.type === 'studies.nursingPlanNote' || props.type === 'studies.treatmentPlan';
    const isTreatmentOrNursingPlan = () => props.type === 'studies.nursingPlanNote' || props.type === 'studies.treatmentPlan';

    const getButtons = () => {
        const buttons = [];
        if (props.noteButton) buttons.push(<AgyleButton onClick={openClinicalNotes}>{t('Add note')}</AgyleButton>);
        if (!props.disableSave) buttons.push(<AgyleButton
            onClick={() => setOpenConfirmDeleted(true)}>{t('Delete')}</AgyleButton>);

        return buttons;
    };

    return (<>
        {props.buttonLabel && (<Grid container spacing={2}>
            <Grid item xs={12} disabled={props.disabled}
                  size={props.size}
                  style={{width: '100%', textAlign: 'center'}}
                // onClick={() => {
                //     if (!props.disableOpen) {
                //         if (!props.value || !props.value.who || !props.value.when) {
                //             setSeen({
                //                 who: seenDefault?.who || props.patient?.currentClinician,
                //                 when: moment().toISOString(),
                //             });
                //         } else {
                //             setSeen(props.value);
                //         }
                //         setText(props.value?.text ? props.value.text : '');
                //         setOpen(true);
                //     }
                // }}
            >
                {/*<Button*/}
                {/*    disabled={props.disabled}*/}
                {/*    size={props.size}*/}
                {/*    style={{width: '100%', textAlign: 'center', cursor: props.disableOpen ? 'auto' : 'pointer'}}*/}
                {/*    disableRipple={props.disableOpen}*/}
                {/*    onClick={() => {*/}
                {/*        if (!props.disableOpen) {*/}
                {/*            if (!props.value || !props.value.who || !props.value.when) {*/}
                {/*                setSeen({*/}
                {/*                    who: seenDefault?.who || props.patient?.currentClinician,*/}
                {/*                    when: moment().toISOString(),*/}
                {/*                });*/}
                {/*            } else {*/}
                {/*                setSeen(props.value);*/}
                {/*            }*/}
                {/*            setText(props.value?.text ? props.value.text : '');*/}
                {/*            setOpen(true);*/}
                {/*        }*/}
                {/*    }}*/}
                {/*    variant="contained"*/}
                {/*    color={props.color}*/}
                {/*>*/}
                <div onClick={() => {
                    if (!props.disableOpen) {
                        if (!props.value || !props.value?.who || !props.value?.when) {
                            setSeen({
                                who: seenDefault?.who || props.patient?.currentClinician,
                                when: moment().toISOString(),
                            });
                        } else {
                            setSeen(props.value);
                        }
                        setText(props.value?.text ? props.value.text : '');
                        if (seenDefault && props.withSpeciality)
                            setSpeciality(props.value?.who?.__id === seenDefault?.who?.__id ? props.value.speciality : null);
                        setOpen(true);
                    }
                }} style={{cursor: props.disableOpen ? 'auto' : 'pointer'}}>
                    {props.buttonLabel(props.value)}
                </div>
                {/*</Button>*/}
            </Grid>
        </Grid>)}

        <MiniFormDialog
            open={open}
            onClose={handleClose}
            onSave={sendChange}
            disableSave={props.disableSave}
            title={`Add ${props?.title || props?.label}`}
            buttons={getButtons()}
            closeButtonOnHeader
            width='sm'
            fullWidth
            disableSubmit={isError || initialNote?.text !== ''}
            formOptions={props?._formOptions}
        >
            <Grid container>
                {props.isActionMode && !props.fromPatientScreen && patientBanner(props.patient, true)}

                {checkIsNursingOrMedicalPlan() &&
                    <MedicalNursePlanInput
                        setFormIsModified={setFormIsModified}
                        medicalNursingNotes={medicalNursingNotes}
                        setMedicalNursingNotes={setMedicalNursingNotes}
                        addBtnSeen={addBtnSeen}
                        setAddBtnSeen={setAddBtnSeen}
                        seenDefault={seenDefault}
                        user={userObject}
                        initialNote={initialNote}
                        setInitialNote={setInitialNote}
                        initNote={initNote}
                        seen={seen}
                    />
                }

                <DialogSeenAndWhenExt
                    patient={props.patient}
                    nurse={props.nurse}
                    cliniciansWithNurses={isTreatmentOrNursingPlan()}
                    size="small"
                    label={props.label}
                    value={seen}
                    allowedConsultants={props.allowedConsultants}
                    onChange={(value) => {
                        setSeen(value);
                        setFormIsModified(true);
                        if (props.withSpeciality) {
                            setSpeciality(null);
                        }
                    }}
                    error={isError}
                    onError={setErrorPicker}
                    admittedDate={props.ambulanceHandover}
                    disableDateManipulation={props.disableDateManipulation}
                    refresh={props.refresh}
                />

                {props.withText && !checkIsNursingOrMedicalPlan() && (<div className={classes.noteField}>
                    <AgyleTextField
                        size={props.refresh ? 'large' : 'small'}
                        className={'custom-dt'}
                        placeholder={t('Enter note')}
                        fullWidth
                        label={t('Note')}
                        onChange={(e) => {
                            setText(e.target.value);
                            setFormIsModified(true);
                        }}
                        value={text}
                        multiline
                        noBorder={!props.refresh}
                        withNewBackground={props.refresh}
                    />
                </div>)}
                {props.withSpeciality && (<div className={classes.noteField}>
                    <AgyleDictionaryField
                        getOptionLabel={option => option.__description}
                        options={dictSpecialties}
                        label={t('Speciality')}
                        loading={dictSpecialtiesLoading}
                        value={speciality}
                        isOptionEqualToValue={(option, value) => option.__id === value.__id}
                        onChange={(_e, newValue) => {
                            setSpeciality(newValue);
                        }}
                        //withBackground={false}
                        //noBorder={false}
                    />
                </div>)}
            </Grid>
        </MiniFormDialog>

        <MessageBox
            title={t('CAUTION')}
            haveAccept={{yes: t('Yes'), no: t('No')}}
            onAccept={handleClear}
            onClose={() => setOpenConfirmDeleted(false)}
            message={t('Are you sure you want delete all recorded values?')}
            open={openConfirmDeleted}
        />

        <NewNoteModal
            open={isClinicalNotesOpen}
            onClose={closeClinicalNotes}
            patient={props.patient}
            disableSave={props.disableSave}
            fromForm={props.noteButtonType}
        />
    </>);
}

export function DialogSeenAndWhenExt(props) {
    const {t} = useTranslation();
    const controller = new AbortController();
    const [consultantsDict, user] = useConsultantsDict(props.allowedConsultants);

    // Dictionaries for Ambulance Handover, Nurses nad Clinicians
    const [dictAmbulanceHO, setDictAmbulanceHO] = useState([]);

    useEffect(() => {
        if (props.admittedDate) {
            loadDict();
        }
    }, []);

    const loadDict = async () => {
        const medicalsStaff = [];

        const allowedConsultants = props.allowedConsultants;
        // const availableIn = props.availableIn;

        let newFilter = 'deactivated ne true and availableIn ne null';

        await API.getDictByURL(
            `/consultants?$filter=${encodeURIComponent(newFilter)}`,
            controller.signal,
        ).then((dictData) => {
            if (dictData) {
                for (let clinician of dictData.__data) {
                    if (allowedConsultants) {
                        if (clinician.availableIn.includes(allowedConsultants)) {
                            medicalsStaff.push({
                                ...clinician,
                                group: 'Consultants',
                            });
                            break;
                        }
                    }
                }
            }
        });

        await API.getDictByURL(`/$dict/Clinicians?$filter=${encodeURIComponent('(forAmbulance eq true and deactivated ne true)')}&$sort=description`).then((dictData) => {
            if (!_.isEmpty(dictData?.__data) && !allowedConsultants) {
                _.forEach(dictData?.__data, (element) => {
                    medicalsStaff.push({
                        ...element, group: 'Clinicians',
                    });
                });
            }
        });

        await API.getDictByURL(`/$dict/Nurses?$filter=${encodeURIComponent('(forAmbulance eq true and deactivated ne true)')}&$sort=description`).then((dictData) => {
            if (!_.isEmpty(dictData?.__data) && !allowedConsultants) {
                _.forEach(dictData?.__data, (element) => {
                    medicalsStaff.push({
                        ...element, group: 'Nurses',
                    });
                });
            }
        });
        setDictAmbulanceHO([...medicalsStaff]);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={props.horizontal ? 12 : 6}>
                {!props.nurse && !props.admittedDate &&
                    <ControlConsultantComponent
                        error={(props.error && !props.value?.who) || !props.value?.who}
                        agyleRefresh
                        size={props.size}
                        allowedConsultants={props.allowedConsultants}
                        label={props.label}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        groupBy={(opt) => props.cliniciansWithNurses ? opt.group : ''}
                        cliniciansWithNurses={props.cliniciansWithNurses}
                        onChange={(value) => {
                            props.onChange({
                                who: value, when: props.value ? props.value?.when : null,
                            });
                        }}
                        refresh={props.refresh}
                        findUser={props.findUser}
                    />
                }

                {props.nurse && !props.admittedDate &&
                    <ControlConsultantComponent
                        typeDict={'Nurses'}
                        agyleRefresh
                        error={(props.error && !props.value?.who) || !props.value?.who}
                        size={props.size}
                        label={props.label}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        groupBy={(opt) => props.cliniciansWithNurses ? opt.group : ''}
                        cliniciansWithNurses={props.cliniciansWithNurses}
                        onChange={(value) => {
                            props.onChange({
                                who: value, when: props.value ? props.value?.when : null,
                            });
                        }}
                        refresh={props.refresh}
                        findUser={props.findUser}
                    />
                }

                {props.admittedDate &&
                    <AgyleDictionaryField
                        label={t('Clinician')}
                        //getOptionLabel={(option) => option?.who?.__description ? option?.who?.__description : option?.__description}
                        getOptionLabel={(option) =>
                            option?.who ?
                                getConsultantName(option?.who) :
                                getConsultantName(option)
                        }
                        //options={dictAmbulanceHO}
                        options={consultantsDict}
                        groupBy={(opt) => opt.group}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        isOptionEqualToValue={(option, value) => option.__id === value?.__id}
                        onChange={(event, newValue) => props.onChange({
                            who: newValue, when: props.value ? props.value?.when : null,
                        })}
                        error={Boolean((props.error && !props.value?.who) || !props.value?.who)}
                        noBorder={!props.refresh}
                        withNewBackground={props.refresh}
                        size={props.refresh ? 'large' : 'small'}
                    />
                }
            </Grid>

            <Grid item xs={props.horizontal ? 12 : 6}>
                <AgyleDatePicker
                    type={'dateTime'}
                    label={t('Date and Time')}
                    disabled={props.disableDateManipulation}
                    inputFormat={config.defaultDateTimeFormat}
                    inputVariant="outlined"
                    error={(props.error && !props.value?.when) || !props.value?.when}
                    value={props.value ? props.value?.when : null}
                    minDate={props.admittedDate ? moment(props.patient?.admission?.startDate) : moment(calculateArrivalDate(props.patient))}
                    maxDate={moment()}
                    onError={props.onError}
                    onChange={(value) => {
                        props.onChange({
                            who: props.value ? props.value?.who : null, when: moment(value).toISOString(),
                        });
                    }}
                    noBorder={!props.refresh}
                    withNewBackground={props.refresh}
                    size={props.refresh ? 'large' : 'small'}
                />
            </Grid>
        </Grid>
    );
}

export {
    ControlClinician,
    DialogSeenAndWhenExt as DialogSeenAndWhen,
    DialogSeen,
    ControlConsultant,
    getConsultantName,
    ControlConsultantComponent,
    getConsultantCode,
};
